import { ProjectService } from '@services/project.service';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of, BehaviorSubject, Subscription, firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import EmbedJSONMapStyle from '@assets/maps/style.json';
import EmbedJSONMapStyleDark from '@assets/maps/style_dark.json';
import EmbedJSONMapStyleLight from '@assets/maps/style_light.json';
import { ILocationModel, LocationModel } from '@models/Common';

//https://github.com/angular/components/tree/main/src/google-maps#readme

export enum EnumMapStyle {
    DEFAULT = 'default',
    LIGHT = 'light',
    DARK = 'dark'
}

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsService {


    private geocoder: google.maps.Geocoder;

    private ApiLoaded: BehaviorSubject<boolean> = new BehaviorSubject(false);

    private apiLoaded = this.ApiLoaded.asObservable();

    private loadedGoogleMaps: any;

    private googleMapsUrl: String = "https://maps.googleapis.com/maps/api";

    constructor(private HttpClient: HttpClient, private ProjectService: ProjectService) {

    }

    // CARREGAMENTO INICIAL DO GOOGLE MAPS
    async Init() {

        if (this.loadedGoogleMaps) return Promise.resolve(this.loadedGoogleMaps);

        const googleKey = this.ProjectService.GetSettings()?.GoogleMaps?.Key || '';

        return new Promise((resolve, reject) => {
            if (this.loadedGoogleMaps) {
                // If already loaded, resolve immediately
                resolve(true);
                return;
            }

            // Create the script element
            const script = document.createElement('script');
            script.src = `${this.googleMapsUrl}/js?libraries=geometry&sensor=false&key=${googleKey}&region=PT&callback=initMap`;
            script.async = true;
            script.defer = true;

            // Set the global callback function
            (window as any).initMap = () => {
                this.geocoder = new google.maps.Geocoder();

                this.loadedGoogleMaps = true;
                this.ApiLoaded.next(true);
                resolve(true);
            };

            // Handle script load error
            script.onerror = () => {
                reject('Google Maps script load error');
                this.loadedGoogleMaps = true;
                this.ApiLoaded.next(false);
            };

            // Append the script to the document
            document.head.appendChild(script);
        });
    }

    /**
     * DEVOLVE OBSERVABLE DO MAPA
     * @returns 
     */
    GetMap() {
        return this.apiLoaded;
    }



    /**
     * 
     * @param style 
     * @returns 
     */
    GetMapStyle(style: EnumMapStyle.DEFAULT | EnumMapStyle.DARK | EnumMapStyle.LIGHT = EnumMapStyle.DEFAULT): google.maps.MapTypeStyle[] {
        //SETUP STYLE FROM JSON FILE
        // return new google.maps.StyledMapType(JSON.parse(JSON.stringify(EmbedJSONMapStyle)), { "name": 'StyledMap' });

        return (style == EnumMapStyle.DARK) ? EmbedJSONMapStyleDark : (style == EnumMapStyle.LIGHT) ? EmbedJSONMapStyleLight : EmbedJSONMapStyle;
    }

    /**
     * 
     * @param street 
     * @returns 
     */
    async GetCoordenatesFromStreetName(street: string = "") {

        const googleKey = this.ProjectService.GetSettings()?.GoogleMaps?.Key || '';

        // const url = `https://maps.googleapis.com/maps/api/place/textsearch/json?query=${encodeURIComponent(street)}&key=${googleKey}`;
        const url = `${this.googleMapsUrl}/geocode/json?address=${street}&key=${googleKey}&region=PT`;

        const http = this.HttpClient.get<any>(url);

        return firstValueFrom(http)
            .then((response: any) => {
                console.log(`Result GET : `, response);

                return response?.status == 'OK' ? response?.results : [];
            })
            .catch(error => {
                console.log(`Error GET : `, error);

                return [];
            });
    }

    /**
     * Geo Code Location
     * @param location 
     * @returns 
     */
    GeoCodeLocation(location: ILocationModel): Promise<ILocationModel> {
        return new Promise((resolve, reject) => {
            let address = [location.Address, location.Locality, location.ZipCode].filter(local => local).join(",");

            if (address) address = address + ", Portugal";

            let request = {
                address: address,
                region: "pt"
            };

            this.geocoder.geocode(request, (results, status) => {
                if (status == 'OK' && results.length > 0) {

                    const location = new LocationModel();

                    location.Coordinates.Latitude = results[0].geometry.location.lat().toString();
                    location.Coordinates.Longitude = results[0].geometry.location.lng().toString();

                    resolve(location);
                }
                else {
                    resolve(new LocationModel());
                }
            });
        });
    }
}
